import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { themeConfig } from 'configs/theme.config'
import {
	LAYOUT_TYPE_MODERN,
	LAYOUT_TYPE_CLASSIC,
	LAYOUT_TYPE_STACKED_SIDE,
	NAV_MODE_TRANSPARENT,
	NAV_MODE_LIGHT,
	NAV_MODE_DARK,
	NAV_MODE_THEMED,
	MODE_DARK,
	MODE_LIGHT,
	LAYOUT_TYPE_DECKED
} from 'constants/theme.constant'

const initialNavMode = (): string => {

	if (themeConfig.layout.type === LAYOUT_TYPE_MODERN && themeConfig.navMode !== NAV_MODE_THEMED) {
		return NAV_MODE_TRANSPARENT
	}

	return themeConfig.navMode
}

const initialState = {
	themeColor: themeConfig.themeColor as string,
    direction: themeConfig.direction as string,
    mode: themeConfig.mode as string,
    locale: themeConfig.locale as string,
    primaryColorLevel: themeConfig.primaryColorLevel as number,
    panelExpand: themeConfig.panelExpand as boolean,
    navMode: initialNavMode(),
    cardBordered: false,
    layout: themeConfig.layout as { type: string; sideNavCollapse?: boolean; previousType?: string }
}

const availableNavColorLayouts = [
	LAYOUT_TYPE_CLASSIC,
	LAYOUT_TYPE_STACKED_SIDE,
	LAYOUT_TYPE_DECKED
]

export const themeSlice = createSlice({
	name: 'theme',
	initialState,
	reducers: {
		setDirection: (state, action: PayloadAction<string>) => {
			state.direction = action.payload
		},
		setMode: (state, action: PayloadAction<string>) => {

			const availableColorNav = availableNavColorLayouts.includes(state.layout.type)

			if (availableColorNav && action.payload === MODE_DARK  && state.navMode !== NAV_MODE_THEMED) {
				state.navMode = NAV_MODE_DARK
			}
			if (availableColorNav && action.payload === MODE_LIGHT && state.navMode !== NAV_MODE_THEMED) {
				state.navMode = NAV_MODE_LIGHT
			}
			state.mode = action.payload
		},
		setLang: (state, action: PayloadAction<string>) => {
			state.locale = action.payload
		},
		setLayout: (state, action: PayloadAction<string>) => {
			state.cardBordered = action.payload === LAYOUT_TYPE_MODERN
			if (action.payload === LAYOUT_TYPE_MODERN) {
				state.navMode = NAV_MODE_TRANSPARENT
			}

			const availableColorNav = availableNavColorLayouts.includes(action.payload)

			if (availableColorNav && state.mode === MODE_LIGHT) {
				state.navMode = NAV_MODE_LIGHT
			}

			if (availableColorNav && state.mode === MODE_DARK) {
				state.navMode = NAV_MODE_DARK
			}

			state.layout = {
				...state.layout,
				...{type: action.payload}
			}
		},
		setPreviousLayout: (state, action: PayloadAction<string>) => {
			state.layout.previousType = action.payload
		},
		setSideNavCollapse: (state, action: PayloadAction<boolean>) => {
			state.layout = {
				...state.layout,
				...{sideNavCollapse: action.payload}
			}
		},
		setNavMode: (state, action: PayloadAction<string>) => {
			if (action.payload !== 'default') {
				state.navMode = action.payload
			} else {
				if (state.layout.type === LAYOUT_TYPE_MODERN) {
					state.navMode = NAV_MODE_TRANSPARENT
				}

				const availableColorNav = availableNavColorLayouts.includes(state.layout.type)

				if (availableColorNav && state.mode === MODE_LIGHT ) {
					state.navMode = NAV_MODE_LIGHT
				}

				if (availableColorNav && state.mode === MODE_DARK ) {
					state.navMode = NAV_MODE_DARK
				}
			}
		},
		setPanelExpand: (state, action: PayloadAction<boolean>) => {
			state.panelExpand = action.payload
		},
		setThemeColor: (state, action: PayloadAction<string>) => {
			state.themeColor = action.payload
		},
		setThemeColorLevel: (state, action: PayloadAction<number>) => {
			state.primaryColorLevel = action.payload
		},
	},
})

export const {
	setDirection,
	setMode,
	setLang,
	setLayout,
	setSideNavCollapse,
	setNavMode,
	setPanelExpand,
	setThemeColor,
	setThemeColorLevel,
	setPreviousLayout
} = themeSlice.actions

export default themeSlice.reducer
